import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import uniq from "lodash/uniq";

function makeMultiReport(selected) {
  if (selected.length < 2) return null;

  const reports = [...selected];
  const last = cloneDeep(reports.pop());

  return reports.reduce((m, category) => {
    Object.entries(category).forEach(([key, value]) => {
      // Data/cache properties need to be merged to identify which properties are mixed
      if (key === "hidden_columns") {
        if (!m[key]) m[key] = {};

        const allkeys = uniq(
          Object.keys(m[key]).concat(Object.keys(value || {})),
        );

        allkeys.forEach((k) => {
          if (m[key][k] == undefined) {
            if (value[k]) {
              m[key][k] = "Mixed";
            } else {
              m[key][k] = value[k];
            }
          } else if (m[key][k] !== value[k]) {
            m[key][k] = "Mixed";
          } else {
            m[key][k] = value[k];
          }
        });
      } else if (typeof value === "object" && isEqual(m[key], value)) {
        m[key] = value;
      } else if (m[key] !== value) {
        if (m[key] == null && value == null) {
          m[key] = null;
        } else {
          m[key] = "Mixed";
        }
      }
    });

    return m;
  }, last);
}

export default makeMultiReport;
